import React from 'react';
import './AnomaliePiece.css';

export const TYPE_ANOMALIE = {
  endommagee: { label: 'Endommagée', kind: 'error',   icon: '🔴' },
  manquante:  { label: 'Manquante',  kind: 'warning', icon: '🟠' },
  back_order: { label: 'Back order', kind: 'warning', icon: 'BO' },
  autre:      { label: 'Autre',      kind: 'muted',   icon: '⚪' },
};

export function BoIcon({ style }) {
  return <span className="bo-icon" style={style}>BO</span>;
}

export function anomalieIcon(type) {
  if (type === 'back_order') return <BoIcon />;
  const t = TYPE_ANOMALIE[type] || TYPE_ANOMALIE.autre;
  return t.icon;
}

export function anomalieBadge(anomalie) {
  if (!anomalie) return null;
  const t = TYPE_ANOMALIE[anomalie.type_anomalie] || TYPE_ANOMALIE.autre;
  return (
    <span className={`cc-badge ${t.kind}`}>
      {anomalieIcon(anomalie.type_anomalie)} {t.label}
    </span>
  );
}
